import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import * as Sentry from "@sentry/react";
import RecruiterDisengageForm from "./RecruiterDisengageForm";
import EngagementsDisengage from "../../apiResources/EngagementsDisengage";
import ExportPdfModal from "./ExportPdf/ExportPdfModal";
import jobProfileType from "./types/jobProfileType";
import {
  JobOptionsButtonWrapper,
  DropdownWrapper,
  DropdownList,
  DropdownListItem,
} from "./styles/edit-button-styles";

class RecruiterJobOptions extends Component {
  constructor(props) {
    super(props);
    this.jobOptionsDropdown = React.createRef();

    this.state = {
      editButtonDropdownActive: false,
      formLoading: false,
      disengagementMessageModalActive: false,
      disengagementMessage: "",
      successMessageActive: false,
      exportPdfModalActive: false,
      errors: null,
    };
  }

  componentDidMount() {
    this.handleDropdownOutsideClick();
  }

  componentWillUnmount() {
    this.handleDropdownOutsideClick();
  }

  handleRecruiterJobOptions = () => {
    this.setState(({ editButtonDropdownActive }) => ({
      editButtonDropdownActive: !editButtonDropdownActive,
    }));
  };

  handleMessageEmployer = () => {
    const { messageEmployerUrl } = this.props;
    window.location.href = messageEmployerUrl;
  };

  handleDropdownOutsideClick = () => {
    document.addEventListener("click", (e) => {
      const { editButtonDropdownActive } = this.state;
      const dropdown = this.jobOptionsDropdown.current;

      if (editButtonDropdownActive === true && e.target !== dropdown) {
        this.setState({ editButtonDropdownActive: false });
      }
    });
  };

  showDisengageModal = () => {
    this.setState({
      disengagementMessageModalActive: true,
    });
  };

  closeModal = () => {
    this.setState({
      formLoading: false,
      disengagementMessageModalActive: false,
      disengagementMessage: "",
      successMessageActive: false,
      errors: null,
    });
  };

  setDisengagementMessage = (e) => {
    this.setState({ disengagementMessage: e.target.value });
  };

  showSuccessMessage = () => {
    this.setState({ successMessageActive: true });
  };

  handleDisengageSubmit = (e) => {
    e.preventDefault();
    const { engagementId } = this.props;
    const { disengagementMessage } = this.state;
    this.setState({ formLoading: true });

    const disengagement = new EngagementsDisengage({
      message: disengagementMessage,
      engagementId,
    });

    disengagement
      .save()
      .then(() => {
        this.setState({ formLoading: true, errors: null });
        this.showSuccessMessage();
        setTimeout(() => {
          this.closeModal();
        }, 2000);
      })
      .catch((error) => {
        Sentry.captureException(error);
        this.setState({ errors: error.response, formLoading: false });
      });

    window.location.replace("/recruiter/engagements");
  };

  toggleExportPdfModal = () => {
    this.setState(({ exportPdfModalActive }) => ({
      exportPdfModalActive: !exportPdfModalActive,
    }));
  };

  render() {
    const {
      editButtonDropdownActive,
      formLoading,
      disengagementMessageModalActive,
      disengagementMessage,
      successMessageActive,
      exportPdfModalActive,
      errors,
    } = this.state;

    const { jobProfile, isPortalUser, recruiterCompanyName } = this.props;

    return (
      <Fragment>
        <RecruiterDisengageForm
          closeModal={this.closeModal}
          formLoading={formLoading}
          modalActive={disengagementMessageModalActive}
          errors={errors}
          successMessageActive={successMessageActive}
          handleDisengageSubmit={this.handleDisengageSubmit}
          setDisengagementMessage={this.setDisengagementMessage}
          disengagementMessage={disengagementMessage}
        />
        {exportPdfModalActive && (
          <ExportPdfModal
            toggleModal={this.toggleExportPdfModal}
            jobProfile={jobProfile}
            isPortalUser={isPortalUser}
            recruiterCompanyName={recruiterCompanyName}
          />
        )}
        <JobOptionsButtonWrapper
          id="job-options-button"
          ref={this.jobOptionsDropdown}
          onClick={this.handleRecruiterJobOptions}
          active={editButtonDropdownActive}
        >
          {editButtonDropdownActive && (
            <DropdownWrapper active={editButtonDropdownActive}>
              <DropdownList>
                <DropdownListItem
                  onClick={this.handleMessageEmployer}
                  data-test-id="job-options-message-employer"
                >
                  Contact Employer
                </DropdownListItem>
                <DropdownListItem
                  onClick={this.showDisengageModal}
                  data-test-id="job-options-disengange"
                >
                  Disengage
                </DropdownListItem>
                <DropdownListItem
                  onClick={this.toggleExportPdfModal}
                  data-test-id="job-pdf-export-toggle"
                >
                  Export to PDF
                </DropdownListItem>
              </DropdownList>
            </DropdownWrapper>
          )}
        </JobOptionsButtonWrapper>
      </Fragment>
    );
  }
}

RecruiterJobOptions.propTypes = {
  jobProfile: jobProfileType.isRequired,
  messageEmployerUrl: PropTypes.string,
  engagementId: PropTypes.number,
  isPortalUser: PropTypes.bool.isRequired,
  recruiterCompanyName: PropTypes.string.isRequired,
};

RecruiterJobOptions.defaultProps = {
  messageEmployerUrl: null,
  engagementId: null,
};

export default RecruiterJobOptions;
